module.exports = __webpack_public_path__ + "static/img/pdf.de65a3e9.jpg";